import React, { useMemo } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Layout, Card, Typography, Space, Tag, Button, Empty, Divider } from "antd";
import { LeftOutlined } from "@ant-design/icons";

import AppHeader from "../../components/Header";
import AppFooter from "../../components/Footer";
import "./index.css";

const { Content } = Layout;
const { Title, Paragraph, Text } = Typography;

export default function PostDetail({ posts, loggedInUser, onLogout }) {
  const { id } = useParams();
  const nav = useNavigate();

  const post = useMemo(() => (posts || []).find((p) => String(p.id) === String(id)), [posts, id]);

  return (
    <Layout className="dmc dmc-layout page-shell detail-layout">
      <AppHeader loggedInUser={loggedInUser} onLogout={onLogout} />

      <Content className="page-content detail-content">
        <div className="detail-container">
          {!post ? (
            <Card className="detail-card">
              <Empty description="文章不存在或已被删除" />
              <div className="detail-center">
                <Button type="primary" onClick={() => nav("/")}>返回首页</Button>
              </div>
            </Card>
          ) : (
            <Card className="detail-card">
              <Space style={{ width: "100%", justifyContent: "space-between" }} align="center">
                <Button icon={<LeftOutlined />} onClick={() => nav(-1)}>返回</Button>
                <Text type="secondary">{post.date}</Text>
              </Space>

              <Divider />

              <Title level={2} style={{ marginTop: 0 }}>{post.title}</Title>

              <Space size={8} wrap>
                {(post.tags || []).map((t) => <Tag key={t}>#{t}</Tag>)}
              </Space>

              {post.summary ? (
                <Paragraph type="secondary" style={{ marginTop: 14 }}>{post.summary}</Paragraph>
              ) : null}

              <Divider />
              <Paragraph className="detail-body">{post.content}</Paragraph>
            </Card>
          )}
        </div>
      </Content>

      <AppFooter />
    </Layout>
  );
}
